import { Component, Inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { BrandingService } from '@shared/branding.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(
    private titleService: Title,
    private brandingService: BrandingService
  ) {
    this.titleService.setTitle(this.brandingService.branding.pageTitle);
  }
}
